module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://shadow.zhaogangimg.com/assets/zgkaihu/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 149);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.number.constructor");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.regexp.exec");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.keys");

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "core-js/modules/es.function.name"
var es_function_name_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/address/src/main.vue?vue&type=template&id=758d1d83&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zg-kh-address" },
    [
      _c(
        "el-popover",
        {
          ref: "popover",
          attrs: {
            placement: "bottom-start",
            width: "454",
            "popper-class": "zg-kh-address-popper-modify",
            trigger: "click",
            "visible-arrow": false,
            "append-to-body": false,
            "popper-options": { modifiersIgnored: ["preventOverflow", "flip"] }
          },
          on: { show: _vm.handlePopShow, hide: _vm.handlePopHide }
        },
        [
          _c(
            "el-input",
            {
              style: { width: _vm.contentWidth },
              attrs: {
                slot: "reference",
                value: _vm.viewValue,
                placeholder: _vm.placeholder,
                type: "text",
                readonly: true
              },
              slot: "reference"
            },
            [
              _c("span", {
                staticClass: "zg-kh-address-arrow",
                class: { "zg-kh-address-arrow-rotate": _vm.showPop },
                attrs: { slot: "suffix" },
                slot: "suffix"
              })
            ]
          ),
          _c(
            "div",
            { staticClass: "zg-kh-address-content" },
            [
              _c(
                "div",
                { staticClass: "zg-kh-address-tabs" },
                [
                  _c("el-scrollbar", { ref: "navScroll" }, [
                    _c(
                      "div",
                      { staticClass: "zg-kh-address-tabs-nav" },
                      _vm._l(_vm.tabs, function(tab, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "zg-kh-address-tab",
                            class: {
                              "zg-kh-address-tab-news":
                                _vm.currentLevelIndex === index
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleTabSelect(index)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(tab.value || "请选择") +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ],
                1
              ),
              _c("el-scrollbar", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.reqLoading,
                        expression: "reqLoading"
                      }
                    ],
                    staticClass: "zg-kh-address-items"
                  },
                  _vm._l(_vm.curLevelData, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "zg-kh-address-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "zg-kh-address-item-label",
                            class: {
                              "is-active":
                                _vm.selected[_vm.currentLevelIndex] &&
                                _vm.selected[_vm.currentLevelIndex].name ===
                                  item.name
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleItemClick(item)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.name) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/address/src/main.vue?vue&type=template&id=758d1d83&

// EXTERNAL MODULE: external "core-js/modules/es.symbol"
var es_symbol_ = __webpack_require__(12);

// EXTERNAL MODULE: external "core-js/modules/es.array.filter"
var es_array_filter_ = __webpack_require__(15);

// EXTERNAL MODULE: external "core-js/modules/es.array.find"
var es_array_find_ = __webpack_require__(30);

// EXTERNAL MODULE: external "core-js/modules/es.array.for-each"
var es_array_for_each_ = __webpack_require__(8);

// EXTERNAL MODULE: external "core-js/modules/es.array.iterator"
var es_array_iterator_ = __webpack_require__(16);

// EXTERNAL MODULE: external "core-js/modules/es.array.join"
var es_array_join_ = __webpack_require__(63);

// EXTERNAL MODULE: external "core-js/modules/es.array.map"
var es_array_map_ = __webpack_require__(28);

// EXTERNAL MODULE: external "core-js/modules/es.array.slice"
var es_array_slice_ = __webpack_require__(17);

// EXTERNAL MODULE: external "core-js/modules/es.number.constructor"
var es_number_constructor_ = __webpack_require__(10);

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptor"
var es_object_get_own_property_descriptor_ = __webpack_require__(26);

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptors"
var es_object_get_own_property_descriptors_ = __webpack_require__(27);

// EXTERNAL MODULE: external "core-js/modules/es.object.keys"
var es_object_keys_ = __webpack_require__(13);

// EXTERNAL MODULE: external "core-js/modules/es.regexp.exec"
var es_regexp_exec_ = __webpack_require__(11);

// EXTERNAL MODULE: external "core-js/modules/es.string.iterator"
var es_string_iterator_ = __webpack_require__(18);

// EXTERNAL MODULE: external "core-js/modules/es.string.split"
var es_string_split_ = __webpack_require__(32);

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.for-each"
var web_dom_collections_for_each_ = __webpack_require__(9);

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.iterator"
var web_dom_collections_iterator_ = __webpack_require__(19);

// EXTERNAL MODULE: external "regenerator-runtime/runtime"
var runtime_ = __webpack_require__(7);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(1);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(2);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/address/src/main.vue?vue&type=script&lang=js&






















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'ZgKhAddress',
  props: {
    placeholder: {
      type: String,
      default: '请选择'
    },
    contentWidth: {
      type: String,
      default: '360px'
    },
    maxLevel: {
      type: Number,
      default: 4
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      viewValue: '',
      showPop: false,
      currentLevelIndex: 0,
      tabs: [{
        value: '',
        level: 'provinces'
      }],
      addressLevel: ['provinces', 'cities', 'areas', 'towns'],
      addressData: {
        provinces: [],
        cities: [],
        areas: [],
        towns: []
      },
      selected: [],
      apis: ['user.getProvinces', 'user.getCities', 'user.getAreas', 'user.getTowns'],
      dataMappers: {
        provinces: {
          code: 'provinceCode',
          name: 'provinceName'
        },
        cities: {
          code: 'cityCode',
          name: 'cityName'
        },
        areas: {
          code: 'areaCode',
          name: 'areaName'
        },
        towns: {
          code: 'townCode',
          name: 'townName'
        }
      },
      reqMaxLevel: null,
      reqLoading: false
    };
  },
  computed: {
    curLevelData: function curLevelData() {
      return this.addressData[this.addressLevel[this.currentLevelIndex]];
    }
  },
  created: function created() {
    this.getData(0);
  },
  methods: {
    handleTabSelect: function handleTabSelect(index) {
      if (this.tabs[index].level === this.addressLevel[this.currentLevelIndex]) {
        return;
      }

      this.currentLevelIndex = index;
    },
    handleItemClick: function handleItemClick(item) {
      var _this = this;

      if (this.selected[this.currentLevelIndex]) {
        this.selected[this.currentLevelIndex] = item;
      } else {
        this.selected.push(item);
      }

      this.tabs[this.currentLevelIndex].value = item.name; //清空已选择的数据

      this.tabs = this.tabs.slice(0, this.currentLevelIndex + 1);
      this.selected = this.selected.slice(0, this.currentLevelIndex + 1);
      this.viewValue = this.tabs.map(function (v) {
        return v.value;
      }).join(' ');
      this.value.selected = JSON.parse(JSON.stringify(this.selected));

      for (var i = this.currentLevelIndex + 1; i < this.addressLevel.length; i++) {
        this.addressData[this.addressLevel[i]] = [];
      }

      this.$emit('onSelect', _objectSpread({
        level: this.addressLevel[this.currentLevelIndex]
      }, item));

      if (this.selected.length === this.maxLevel) {
        this.$nextTick(function () {
          if (_this.$refs.navScroll) {
            _this.$refs.navScroll.wrap.scrollLeft = _this.$refs.navScroll.wrap.scrollWidth;
          }
        });
        this.$emit('onFinish', JSON.parse(JSON.stringify(this.selected)));
        this.$refs.popover && this.$refs.popover.doClose();
        return;
      }

      if (this.currentLevelIndex + 1 === this.addressLevel.length) {
        return;
      } //有没有下一页数据需要请求接口才清除


      this.getData(this.currentLevelIndex + 1);
    },
    getData: function getData(apiIndex) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var api, params, resp, _this2$$zgKaihu$$conv, success, data, mapper;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this2.reqLoading = true;
                api = _this2.apis[apiIndex];
                params = {};

                if (apiIndex === 0) {
                  params.provinceCode = '';
                } else {
                  params.fatherCode = _this2.selected[apiIndex - 1].code;
                }

                _context.next = 7;
                return _this2.$zgKaihu.$get(api, params, {
                  notNeedLoading: true
                });

              case 7:
                resp = _context.sent;
                _this2$$zgKaihu$$conv = _this2.$zgKaihu.$convertResp(resp), success = _this2$$zgKaihu$$conv.success, data = _this2$$zgKaihu$$conv.data;
                _this2.reqLoading = false;

                if (success && data) {
                  if (data.value) {
                    if (apiIndex !== 0) {
                      _this2.currentLevelIndex = apiIndex;

                      _this2.tabs.push({
                        value: '',
                        level: _this2.addressLevel[_this2.currentLevelIndex]
                      });
                    }

                    mapper = _this2.dataMappers[_this2.addressLevel[_this2.currentLevelIndex]];
                    _this2.addressData[_this2.addressLevel[apiIndex]] = data.value.map(function (v) {
                      return _objectSpread({}, v, {
                        code: v[mapper.code],
                        name: v[mapper.name]
                      });
                    });

                    _this2.$nextTick(function () {
                      if (_this2.$refs.navScroll) {
                        _this2.$refs.navScroll.wrap.scrollLeft = _this2.$refs.navScroll.wrap.scrollWidth;
                      }
                    });
                  } else {
                    //没有数据，可以选择关闭弹窗
                    _this2.$emit('onFinish', JSON.parse(JSON.stringify(_this2.selected)));

                    _this2.reqMaxLevel = apiIndex;
                    _this2.$refs.popover && _this2.$refs.popover.doClose();
                  }
                } else {
                  _this2.addressData[_this2.addressLevel[apiIndex]] = [];
                }

                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);
                _this2.reqLoading = false;
                _this2.addressData[_this2.addressLevel[apiIndex]] = [];

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }))();
    },
    handlePopShow: function handlePopShow() {
      this.showPop = true;

      if (!this.viewValue) {
        this.clearData();
      }

      if (this.addressData.provinces.length === 0) {
        this.getData(0);
      }
    },
    handlePopHide: function handlePopHide() {
      this.showPop = false; //针对于第四级数据可能没有的情况

      var realLevel = this.reqMaxLevel ? this.reqMaxLevel : this.maxLevel;
      this.reqMaxLevel = null;

      if (this.selected.length !== realLevel) {
        this.viewValue = '';
        this.value.selected = null;
        this.clearData();
      }
    },
    clearData: function clearData() {
      var _this3 = this;

      this.currentLevelIndex = 0;
      this.tabs = [{
        value: '',
        level: 'provinces'
      }];
      this.selected = [];
      Object.keys(this.addressData).forEach(function (key) {
        if (key !== 'provinces') {
          _this3.addressData[key] = [];
        }
      });
    },
    setValue: function setValue(value) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var initArr, _loop, i, _ret;

        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                //清空已选择数据
                _this4.viewValue = '';
                _this4.value.selected = null;

                _this4.clearData(); //初始化值


                initArr = value.split(' ');
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
                  var item;
                  return regeneratorRuntime.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(i === 0 && _this4.addressData[_this4.addressLevel[i]].length === 0)) {
                            _context2.next = 3;
                            break;
                          }

                          _context2.next = 3;
                          return _this4.getData(i);

                        case 3:
                          if (!(i !== 0)) {
                            _context2.next = 6;
                            break;
                          }

                          _context2.next = 6;
                          return _this4.getData(i);

                        case 6:
                          if (!(_this4.addressData[_this4.addressLevel[i]].length === 0)) {
                            _context2.next = 9;
                            break;
                          }

                          //没有获取到数据
                          _this4.handlePopHide();

                          return _context2.abrupt("return", "break");

                        case 9:
                          item = _this4.addressData[_this4.addressLevel[i]].find(function (item) {
                            return item.name === initArr[i];
                          });

                          if (_this4.selected[_this4.currentLevelIndex]) {
                            _this4.selected[_this4.currentLevelIndex] = item;
                          } else {
                            _this4.selected.push(item);
                          }

                          _this4.tabs[_this4.currentLevelIndex].value = item.name;
                          _this4.viewValue = _this4.tabs.map(function (v) {
                            return v.value;
                          }).join(' ');
                          _this4.value.selected = JSON.parse(JSON.stringify(_this4.selected));

                        case 14:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _loop);
                });
                i = 0;

              case 6:
                if (!(i < initArr.length)) {
                  _context3.next = 14;
                  break;
                }

                return _context3.delegateYield(_loop(i), "t0", 8);

              case 8:
                _ret = _context3.t0;

                if (!(_ret === "break")) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("break", 14);

              case 11:
                i++;
                _context3.next = 6;
                break;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2);
      }))();
    },
    clearAddress: function clearAddress() {
      this.viewValue = '';
      this.value.selected = null;
      this.clearData();
    }
  }
});
// CONCATENATED MODULE: ./packages/address/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/address/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/address/src/main.vue"
/* harmony default export */ var main = (component.exports);
// CONCATENATED MODULE: ./packages/address/index.js


/* istanbul ignore next */

main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var address = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.filter");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.iterator");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.slice");

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.iterator");

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.iterator");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptor");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptors");

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.map");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.function.name");

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.find");

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.split");

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.join");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("regenerator-runtime/runtime");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.for-each");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.for-each");

/***/ })

/******/ });